import { render, staticRenderFns } from "./LanguagesFormComponent.vue?vue&type=template&id=2b6cb7b4&scoped=true"
import script from "./LanguagesFormComponent.vue?vue&type=script&lang=js"
export * from "./LanguagesFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6cb7b4",
  null
  
)

export default component.exports